import IUMBInventory from '../../main/interfaces/IUMBInventory';

export interface UmbrellaPriceSummaryItem {
  count: number;
  price: number;
}

const getUmbrellaPriceSummary = (inventory: IUMBInventory[]): UmbrellaPriceSummaryItem[] => {
  const countByPrice = new Map<number, number>();

  inventory.forEach((item) => {
    const price = Number(item.price || 0);
    countByPrice.set(price, (countByPrice.get(price) || 0) + 1);
  });

  return Array.from(countByPrice, ([price, count]) => ({ price, count })).sort((a, b) => b.price - a.price);
};

export default getUmbrellaPriceSummary;
